import "./EditProfileButton.scss";

import EditProfileButton from "./EditProfileButton";

export default EditProfileButton;
